import React, { useEffect, useState, useMemo } from "react"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import TableContainer from "components/Common/TableContainer"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import Select from "react-select"
import { isEmpty } from "lodash"
//redux
import { useSelector, useDispatch } from "react-redux"
import Spinners from "components/Common/Spinner"
import { ToastContainer } from "react-toastify"
import { getConfiguration, updateConfig } from "helpers/fakebackend_helper"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import ImagePopup from "pages/Home-Page/ImagePopup"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

const Configuration = () => {
  //meta title
  // document.title = "Configuration";

  const dispatch = useDispatch()
  const router = useNavigate()

  const [isLoading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)

  const [list, setList] = useState([])

  const getList = () => {
    setLoading(true)
    let payload = {}
    getConfiguration()
      .then(res => {
        setList(res)
        setLoading(false)
      })
      .catch(err => {
        console.log("err", err)
        setLoading(false)
      })
  }

  useEffect(() => {
    getList()
  }, [])

  const handleUserClicks = () => {
    router("/form-book")
  }

  // const handleStatus = (status) => {
  //   changeBookStatus(status).then(res => {
  //     if (res?.success) {
  //       getList();
  //       toast.success(res?.message ?? 'Status Updated')
  //     } else {
  //       toast.error(res?.message ?? 'somthing went wrong!')
  //     }
  //   }).catch(err => {
  //     console.log('err', err);
  //   })
  // }

  const [configurationData, setConfigurationData] = useState({})
  const [types, settypes] = useState("")
  const [values, setvalues] = useState("")

  const res = [
    {
      id: 1,
      config_name: "MAX_FILE_SIZE",
      config_value: "10.0",
      validation: 1,
      created_at: "2025-02-02T14:38:33.259Z",
      updated_at: "2025-02-02T14:38:33.259Z",
    },
  ]

  const handleUpdate = payload => {
    updateConfig(payload)
      .then(res => {
        if (res?.success) {
          toast.success(res?.message ?? "Upadte SuccessFull!")
          setModal(false)
          getList()
        } else {
          toast.error(res?.message ?? "Somthing went wrong")
        }
      })
      .catch(err => {
        console.log("err", err)
        toast.error(err?.message ?? "Somthing went wrong")
      })
  }

  const validations = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (configurationData && configurationData.config_name) || "",
      value: (configurationData && configurationData.config_value) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter  Name"),
    }),
    onSubmit: values => {
      const payload = new FormData()
      payload.append("config_id", configurationData?.id)
      payload.append("config_value", values.value)
      payload.append("config_name", values.name)
      payload.append("validation", configurationData?.validation)
      handleUpdate(payload)
    },
  })

  const getData = item => {
    // setContacts(item)
    setConfigurationData(item)
    validations.setFieldValue("name", item?.config_name)
    validations.setFieldValue("value", item?.config_value)
    setModal(true)
  }

  console.log("config_nameconfig_name", validations.getFieldProps("name").value)
  
    const [image_path, setImage_path] = useState("")
      const [showPopup, setShowPopup] = useState(false)
      const handleClose = () => setShowPopup(false)

  const getImg = image_ => {
    setImage_path(image_)
    setShowPopup(true)
  }

  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell, row) => {
          return (
            <>
              <h5 className="font-size-14 mb-1">{cell.row.index + 1}</h5>
            </>
          )
        },
      },

      {
        header: "Name",
        accessorKey: "config_name",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Type",
        accessorKey: "validation",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell, row) => {
          return (
            <>
              {/* <h5 className='font-size-14 mb-1'>
                {cell?.row?.original?.validation == 1 ? 'Max File Size' :
                  cell?.row?.original?.validation == 2 ? "Header Title" : cell?.row?.original?.validation == 3 ? "Header Image" : ""}
              </h5> */}
              <h5 className="font-size-14 mb-1">
                {cell?.row?.original?.validation == 1
                  ? "Number"
                  : cell?.row?.original?.validation == 2
                  ? "Text"
                  : cell?.row?.original?.validation == 3
                  ? "File"
                  : ""}
              </h5>
            </>
          )
        },
      },

      {
        header: "Value",
        accessorKey: "config_value",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell, row) => {
          return (
            <>
              {cell?.row?.original?.validation == 3 ? (
                <h3 className="" onClick={()=>getImg(cell?.row?.original?.config_value)}>
                  <i className="bx bxs-image"></i>
                </h3>
              ) : cell?.row?.original?.config_name == "THIRUKURAL" ? (
                <div dangerouslySetInnerHTML={{__html:cell?.row?.original?.config_value}}></div>
              ) :  (
                <h5 className="font-size-14 mb-1">
                  {cell?.row?.original?.config_value}
                </h5>
              )}
            </>
          )
        },
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <button
                className=" border-0 bg-none text-primary rounded "
                onClick={() => getData(cellProps.row.original)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  const toggle = () => {
    setModal(!modal)
  }

  return (
    <React.Fragment>
            <ImagePopup
        showPopup={showPopup}
        handleClose={handleClose}
        image_path={image_path}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="" breadcrumbItem="Configuration List" />
          <Row>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={list || []}
                      isGlobalFilter={true}
                      isPagination={true}
                      SearchPlaceholder="Search..."
                      isCustomPageSize={true}
                      tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          Edit Configuration
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validations.handleSubmit()
              return false
            }}
          >
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <Label>Name<span className="text-danger">*</span></Label>
                  {/* <Select
                    options={[{ label: 'MAX FILE SIZE', value: 'MAX_FILE_SIZE' }, { label: 'HEADER1 TITLE', value: 'HEADER1_TITLE' }, { label: 'HEADER1 ENG TITLE', value: 'HEADER1_ENG_TITLE' }, { label: 'HEADER1 TAMIL TITLE', value: 'HEADER1_TAMIL_TITLE' }, { label: 'HEADER1 IMAGE', value: 'HEADER1_IMAGE' }]}
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    name="class_id"
                    value={[{ label: 'MAX FILE SIZE', value: 'MAX_FILE_SIZE' }, { label: 'HEADER1 TITLE', value: 'HEADER1_TITLE' }, { label: 'HEADER1 ENG TITLE', value: 'HEADER1_ENG_TITLE' }, { label: 'HEADER1 TAMIL TITLE', value: 'HEADER1_TAMIL_TITLE' }, { label: 'HEADER1 IMAGE', value: 'HEADER1_IMAGE' }].find(e => e.value == validations.getFieldProps('name').value)}
                    placeholder='Select Class'
                    onChange={(e) => validations.setFieldValue('name', e.value)}
                    className="select2-selection"
                    isDisabled
                  /> */}
                  <Input
                    name="config_name"
                    value={validations.getFieldProps("name").value}
                    isDisabled
                  />
                  {/* {bookFormik.touched.class_id && bookFormik.errors.class_id ? (
                          <p className="mb-0 text-danger mt-1" >{bookFormik.errors.class_id}</p>
                      ) : null} */}
                </div>
              </Col>

              <Col md="12">
                <div className="mb-3">
                  <Label>Type<span className="text-danger">*</span></Label>
                  <Input
                    name="type"
                    isDisabled
                    value= {configurationData?.validation == 3
                      ?  "File"
                      : configurationData?.validation == 1
                      ?  "Number"
                      : configurationData?.validation == 2
                      ? "Text"
                      : "Text"}
                  />
                </div>
              </Col>

              <Col xs={12}>
                <div className="mb-3 thiru">
                  <Label className="form-label">Value<span className="text-danger">*</span></Label>
                  {configurationData?.validation == 3 ? (
                    <Input
                      name="value"
                      type={"file"}
                      placeholder="Insert value"
                      onChange={e =>
                        validations.setFieldValue("value", e.target.files[0])
                      }
                      // onChange={validations.handleChange}
                      onBlur={validations.handleBlur}
                      invalid={
                        validations.touched.value && validations.errors.value
                          ? true
                          : false
                      }
                    />
                  ) : validations.getFieldProps("name").value == "THIRUKURAL" ? (
                    <CKEditor
                        editor={ClassicEditor}
                        data={validations.getFieldProps("value").value}
                        onChange={(event, editor) => {
                        const data = editor.getData()
                        validations.setFieldValue("value", data)
                        }}
                        config={{
                        toolbar: {
                            items: [
                            "undo", "redo","|","bold",
                            "italic","|","numberedList","bulletedList",
                            ],
                            maxWordCount: 10,
                        },

                        }}
                    />
                  ) : (
                    <Input
                      name="value"
                      type={
                        configurationData?.validation == 1 ? "number" : "text"
                      }
                      placeholder="Insert value"
                      onChange={e =>
                        validations.setFieldValue("value", e.target.value)
                      }
                      // onChange={validations.handleChange}
                      onBlur={validations.handleBlur}
                      value={validations.values.value || ""}
                      invalid={
                        validations.touched.value && validations.errors.value
                          ? true
                          : false
                      }
                    />
                  )}
                  {configurationData?.validation == 3 &&
                    validations.values.value && (
                      <p className="mt-2 ">
                        <span className="text-primary">Selected File:</span>{" "}
                        {validations.values.value.name}
                      </p>
                    )}
                  {validations.touched.value && validations.errors.value ? (
                    <FormFeedback type="invalid">
                      {validations.errors.value}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button type="submit" className="btn btn-success save-user">
                    Update
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(Configuration)
